import * as userTokenRequests from "../../api/userTokenRequest";
import {START_LOAD, FINISH_LOAD} from "../reducers/teams";
import {push} from "./message";
import {EN} from '../../ui/constants';

const startLoading = () => {
    return {type: START_LOAD};
};
const finishLoading = (teams) => {
    return {type: FINISH_LOAD, payload: teams};
};

export const getTeams = (isGroupBy) => {
    return dispatch => {
        dispatch(startLoading());
        userTokenRequests.getTeamsList(isGroupBy)
            .then(teams => {
                dispatch(finishLoading(teams))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};

export const createNewTeam =  (car_info, team_info) => {
    return dispatch => {
        dispatch(startLoading());
        return userTokenRequests.createTeam(car_info, team_info)
            .then(teams => {
                dispatch(push(EN.message.create_team));
                dispatch(finishLoading(teams));
                return teams
                // return new Promise((resolve, reject) => resolve(teams))
            })
            .catch(error => {
                dispatch(finishLoading(null));
                dispatch(push(error.message))
            })
    }
};